export default function searchValue(data,value,key=null,exactMatch=false,showAllOnEmpty=false) {
    if(!value&&!showAllOnEmpty){
        return[];
    }
    if(!value&&showAllOnEmpty){
        return data;
    }

    return data.filter(item=>{
        const itemValues=Object.values(item);
        if(exactMatch){
            return itemValues.some(val=>{
                if(val===null)return false;
                return val===value
            });
        }

        return itemValues.some(val=>{
            if(val===null)return false;
            return val.toString().toLowerCase().includes(value.toString().toLowerCase());
        })
    });
}